import React from 'react';
import { ImageIcon } from 'lucide-react';

// Real images (uploaded by user). Order matters for layout.
const beachImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/r9o2ri5s_Darker%20-%202026-05-01T125837.289.jpg',
    alt: 'Endless Summer & Tropical Bar Surfboards am Saale Beach',
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/63g75awm_Darker%20-%202026-05-01T130550.679.jpg',
    alt: 'Saale Beach bei Nacht mit Lichterketten',
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/3whieuao_Darker%20-%202026-05-01T131132.864.jpg',
    alt: 'Blick durch den Rettungsring auf die Liegestühle',
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/uupq4nwd_IMG-20260430-WA0083.jpg',
    alt: 'Sonnenliegen im Sand am Saale Beach',
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/blo5k9v2_IMG-20260430-WA0100.jpg',
    alt: 'Surfbrett',
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/tnx6lap6_IMG-20260430-WA0110.jpg',
    alt: 'Holzdeck mit Tischen und Sonnenschirmen am Abend',
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/ez4pagoa_IMG-20260430-WA0131.jpg',
    alt: 'Surfbrett vor Mondlicht und Wimpelketten',
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/4xeur4kf_IMG-20260430-WA0134.jpg',
    alt: 'Lichterketten in der Abenddämmerung',
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/e5f5f38v_IMG-20260430-WA0139.jpg',
    alt: 'Liegestühle und Sonnenschirme bei Nacht',
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/7133uq8h_IMG-20260430-WA0148.jpg',
    alt: 'Holztisch mit Blick auf die Beach Lounge',
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/jjna8wtn_Darker%20-%202026-05-01T152257.553.jpg',
    alt: 'Kanu-Tour am Saale-Ufer',
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/24lpj8nx_Darker%20-%202026-05-01T152249.379.jpg',
    alt: 'Kanus am Saale-Ufer',
  },
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/8ckm9bns_Darker%20-%202026-05-01T152237.818.jpg',
    alt: 'Kanutour',
  },
];

const TOTAL_SLOTS = 13;

const BeachGallerySection = () => {
  const placeholderCount = Math.max(0, TOTAL_SLOTS - beachImages.length);

  return (
    <section
      id="beach-gallery"
      className="py-20 px-4"
      style={{ background: 'linear-gradient(to bottom, #0A0015, #050010)' }}
      data-testid="beach-gallery-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Galerie Saale Beach
          </h2>
          <div
            className="h-1 w-24 mx-auto rounded-full mb-6"
            style={{
              background: 'linear-gradient(to right, #FFFF00, #FFD700)',
              boxShadow: '0 0 15px #FFFF00',
            }}
          />
          <p
            className="text-white/70 text-lg"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Eindrücke vom Saale Beach Hammelburg
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {beachImages.map((image) => (
            <div
              key={image.id}
              data-testid={`beach-gallery-image-${image.id}`}
              className="relative overflow-hidden rounded-lg group cursor-pointer aspect-square"
            >
              <img
                src={image.url}
                alt={image.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110"
              />
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                  background:
                    'linear-gradient(to top, rgba(10,0,21,0.85) 0%, rgba(10,0,21,0.2) 50%, transparent 100%)',
                }}
              >
                <div className="absolute bottom-4 left-4 right-4">
                  <p
                    className="text-white font-semibold text-base"
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      textShadow: '0 0 10px rgba(255, 255, 0, 0.6)',
                    }}
                  >
                    {image.alt}
                  </p>
                </div>
              </div>
            </div>
          ))}

          {Array.from({ length: placeholderCount }, (_, i) => (
            <div
              key={`placeholder-${i}`}
              data-testid={`beach-gallery-placeholder-${i + 1}`}
              className="relative overflow-hidden rounded-lg aspect-square flex flex-col items-center justify-center transition-all duration-300 hover:scale-[1.02]"
              style={{
                background:
                  'linear-gradient(135deg, rgba(255, 255, 0, 0.05) 0%, rgba(255, 215, 0, 0.02) 100%)',
                border: '1px dashed rgba(255, 255, 0, 0.35)',
                boxShadow: 'inset 0 0 30px rgba(255, 255, 0, 0.05)',
              }}
            >
              <ImageIcon
                className="w-12 h-12 mb-3"
                style={{
                  color: '#FFFF00',
                  filter: 'drop-shadow(0 0 8px #FFFF00)',
                }}
              />
              <p
                className="text-white/70 text-sm tracking-wide uppercase"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Bild folgt
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeachGallerySection;
